
import React from "react";
import styled from "styled-components";
import Iconmoon from "../IconsFiles/icon";
import {Button,} from "antd";

const AlertCard = styled.div`
    border-radius:8px;
    z-index: 1000;
    &.red{
    .alertBox{
        border:1px solid rgba(236, 78, 44, 0.2);
        background-color:rgba(235, 78, 44, 0.1);
        z-index: 1000;
    }
    .closeButtonbg{
        background-color: #fdede9 !important;
margin: auto;
    }
    }
    &.green{
    .alertBox{
        border:1px solid rgba(63, 189, 97, 0.2);
        background-color:rgba(63, 190, 97, 0.1);;
        z-index: 1000;
    }
    .closeButtonbg{
        background-color: #e7f4ea !important;
        margin: auto;
    }
    }
    &.yellow{
        .alertBox{
            background: rgba(238, 149, 0, 0.1);
            border: 1px solid rgba(238, 149, 0, 0.2);
        }
    }
    &.blue{
        .alertBox{
            background: rgba(0, 108, 229, 0.1);
            border: 1px solid rgba(0, 108, 229, 0.2);
            margin-bottom: 20px;
        }
    }
    .alertBox{
    padding:8px 30px 8px 12px;
    border-radius:8px;
    min-height:50px;
    width:100%;
    display:flex;
    align-items:center;
    // margin-bottom : 15px;
    .alertIcon{
        width:34px;
        height:34px;
        position:relative;
        top:2px;
        align-self:center;
        img{
            width:100%;
        }
    }
    p{
        color:var(--para-text);
        font-size:12px;
        line-height:16px;
        font-family:var(--sf-pro-display-m);
        margin-left:15px;
        margin-bottom:0px;
        width:calc(100% - 40px);
    }
    }
`;

const AlertContainer = (props) => {
    return (<AlertCard className={props.color} > 
    <div className="alertBox" style={{transform: props?.marginTop ? `translateY(${props.marginTop})` : '', position: props?.marginTop ? "absolute" : ""}}>
        <div  className="alertIcon">
            <img style={{width : props.jobCard ? '60%' : ''}} src={props.icon} alt=""/>
        </div>
        <p dangerouslySetInnerHTML={{ __html:props.msg}}></p>
        {props.closeIcon && <Button className="textTypeBtn textBtnIcon paperButtonBg closeButtonbg" onClick={()=>props.setClose(false)}>
        <Iconmoon icon="wrong" size={14} color="#EA655B" />
        </Button>}
    </div>

    </AlertCard>)
}
export default AlertContainer;
